<template>
    <div v-if="packs !== null" class="d-grid plan-grid gap-4">
        <div class="card price-card d-flex flex-column" v-for="pack in packs" :class="{'main' : pack.highlighted, 'selected' : pack === selectedPack}">
            <div class="card-header pt-5 pb-2">
                <div v-if="pack.highlighted" class="ribbon text-capitalize">{{$t('general.best_value')}}</div>
                <translate :data="pack.title"></translate>
            </div>

            <div class="card-body pt-0 flex-grow-1 text-left">
                <hr class="mt-0">
                <div>
                    <translate :data="pack.description"></translate>
                </div>

                <ul>
                    <li>
                        {{pack.token_amount}} {{$t('general.credits')}}
                    </li>
                    <li>
                        {{pack.price_per_unit}}€ / {{$t('general.credit')}}
                    </li>
                </ul>
            </div>

            <div class="price flex-column border-none pb-5">
                <hr class="my-0 pb-2">

                <div>
                    <span>{{pack.price}}€</span>
                </div>

                <button v-if="showOrderButtons" class="btn btn-primary btn-big mt-2" type="button" @click="selectPack(pack)">
                    <template v-if="selectedPack === pack">
                        {{$t('general.selected')}}
                    </template>
                    <template v-else>
                        {{$t('general.select_this_plan')}}
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @use "../../../sass/client/breakpoints" as br;

    $headerSize: 1.4em;
    $baseFontSize: 1.06em !important;
    $priceFontSize: 1.8em;

    .d-grid.plan-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, 16.7rem);

        @media (max-width: br.$breakpoint-md) {
            grid-template-columns: unset !important;
            grid-auto-flow: column;
            overflow-x: scroll;

            margin: -20px;
            margin-bottom: -10px;
            padding: 20px;

            & > * {
                min-width: 200px;
            }
        }
    }

    .price-card {
        display: inline-block;
        text-align: center;
        overflow: hidden;

        height: 100%;

        box-shadow: 0 8px 15px 0 #0202020a;
        border-color: rgba(0, 0, 0, 0.04);

        font-size: .9rem;

        &.selected {
            outline: 2px solid #4c7cf30a;
            /*box-shadow: 0 2px 8px 0 #4c7cf33d;*/
            box-shadow: 0 8px 15px 0 rgba(2, 2, 2, 0.11);

            transform: scale(1.02);
        }

        .card-header {
            font-size: $headerSize;
            font-weight: 500;
            border: none;
            background-color: unset;
            transition: font-size 0.3s;
            justify-content: center;
        }

        .card-body {
            font-size: $baseFontSize;
            padding: 0 2rem;
        }

        hr {
            width: 8rem;
        }

        ul {
            padding: 0;
            margin: 0;
            list-style: none;
        }

        li {
            margin: .5rem 0;
            font-size: $baseFontSize;

            &:before {
                content: '';
                background-image: url('/images/check.svg');
                background-repeat: no-repeat;
                background-position: left;
                line-height: 26px;
                padding-left: 15%;
            }
        }

        .price {
            font-weight: 500;
            font-size: $priceFontSize;
            color: #4c7cf3;

            margin-top: 4rem;

            .time-period {
                font-size: 0.4em;
                color: #9f9f9f;
            }
        }
    }

    .ribbon {
        width: 160px;
        height: 2rem;
        font-size: .7rem;
        text-align: center;
        color: #fff;
        font-weight: bold;
        box-shadow: 0px 2px 3px rgba(136, 136, 136, 0.25);
        background: #4c7cf3;
        transform: rotate(45deg);
        position: absolute;
        right: -42px;
        top: 20px;
        padding-top: 0.43rem;
    }
</style>

<script>
    export default {
        props: ['packs', 'showOrderButtons'],
        data: function () {
            return {
                selectedPack: null,
            }
        },
        methods: {
            selectPack (pack) {
                this.selectedPack = pack;
                this.$emit('selectPack', pack);
            }
        }
    }
</script>
